// Add your custom JS here.

(function($) {
    $(document).ready(function() {
        $('.wp-block-portfolio__tab').click(function() {
          const $container = $(this).closest('.wp-block-portfolio');
          $container.addClass('active');
          const country = $(this).data('country');
          const region = $(this).data('region');
          const isActive = $(this).hasClass('active');

          $container.find('.wp-block-portfolio__tab').removeClass('active');

          if (isActive) {
            $container.find('.wp-block-portfolio__company').show()
          } else {
            $(this).addClass('active');

            $container.find('.wp-block-portfolio__company').each(function() {
              if ($(this).data('country') !== country && $(this).data('region') !== region) {
                $(this).hide();
              } else {
                $(this).show();
              }
            })
          }
        })
    });
})(jQuery);